export function parseRestockRows(data, stockItems, parseNumber) {
  const headers = (data[0] || []).map(value => String(value || '').trim());
  const aliases = new Set(['onupdate', 'update', 'updated']);
  const updates = headers.map((header, index) => aliases.has(header.toLowerCase()) ? index : -1).filter(index => index >= 0);
  const idIndex = headers.indexOf('ID');
  if (idIndex < 0 || updates.length !== 1) throw new Error('INVALID_RESTOCK_HEADERS');
  const ids = new Set(stockItems.map(item => item.id));
  const rows = [], errors = [];
  let ignored = 0;
  data.slice(1).forEach((row, index) => {
    const raw = String(row[updates[0]] ?? '').trim();
    const quantity = parseNumber(raw), stockItemId = String(row[idIndex] ?? '').trim();
    if (!raw || quantity === 0) { ignored++; return; }
    if (!ids.has(stockItemId) || quantity == null || !Number.isFinite(quantity) || quantity < 0) {
      errors.push({ line: index + 2, stockItemId });
      return;
    }
    rows.push({ stockItemId, quantity, line: index + 2 });
  });
  return { rows, errors, ignored };
}
